import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { createContextFactory } from '@streem/toolbox';
import { useInitializeLinkButtonContext, } from './use_initialize_link_button_context';
import { useInitializeTextHeadingDropdownContext, } from './use_initialize_text_heading_dropdown_context';
import { useInitializeListButtonsContext, } from './use_initialize_list_buttons_context';
import { useInitializeDividerButtonContext, } from './use_initialize_divider_button_context';
import { useInitializeTextEmphasisButtonsContext, } from './use_initialize_text_emphasis_buttons_context';
const [InternalNotesToolbarContextProvider, useNotesToolbarContext,] = createContextFactory('NotesToolbarContext');
export { useNotesToolbarContext };
export function NotesToolbarContextProvider({ children }) {
    const linkButtonContext = useInitializeLinkButtonContext();
    const textEmphasisButtonsContext = useInitializeTextEmphasisButtonsContext();
    const textHeadingDropdownContext = useInitializeTextHeadingDropdownContext();
    const listButtonsContext = useInitializeListButtonsContext();
    const dividerButtonContext = useInitializeDividerButtonContext();
    // Note: this function is currently stable - but make sure the functions and values remain that way
    const onSelectionUpdated = useCallback((ctx, selection) => {
        textEmphasisButtonsContext.selectionForTextEmphasis(ctx, selection);
        textHeadingDropdownContext.selectionForHeading(ctx, selection);
        listButtonsContext.selectionForLists(ctx, selection);
        linkButtonContext.selectionForLink(ctx, selection);
        dividerButtonContext.selectionForDivider(ctx, selection);
    }, [
        linkButtonContext,
        listButtonsContext,
        textHeadingDropdownContext,
        dividerButtonContext,
        textEmphasisButtonsContext,
    ]);
    const contextValue = useMemo(() => {
        return {
            onSelectionUpdated,
            textEmphasisButtonsContext,
            linkContext: linkButtonContext,
            textHeadingDropdownContext,
            listsContext: listButtonsContext,
            dividerButtonContext,
        };
    }, [
        onSelectionUpdated,
        textEmphasisButtonsContext,
        linkButtonContext,
        textHeadingDropdownContext,
        listButtonsContext,
        dividerButtonContext,
    ]);
    return (_jsx(InternalNotesToolbarContextProvider, { value: contextValue, children: children }));
}
//# sourceMappingURL=notes_toolbar_context.js.map